/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notification_Empty_BodyInputs */



/**
* | output |
* | --- |
* | "New access to projects, spaces and teams shows up here." |
*
* @param {Notification_Empty_BodyInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const notification_empty_body = /** @type {((inputs?: Notification_Empty_BodyInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notification_Empty_BodyInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Neue Zugriffe auf Projekte, Bereiche und Teams erscheinen hier.")
	return /** @type {LocalizedString} */ ("New access to projects, spaces and teams shows up here.")
});